import { Link } from 'react-router-dom';
import { posts } from '@/mocks/posts';

export default function DeepFeature() {
  const deepPosts = posts.filter((p) => p.categorySlug === 'deep');
  const main = deepPosts[0];
  const rest = deepPosts.slice(1);

  if (!main) return null;

  return (
    <section className="w-full bg-foreground-950 px-4 py-12 md:px-8" aria-labelledby="deep-heading">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
            <i className="ri-file-search-line" aria-hidden="true"></i>
            编辑部出品
          </span>
          <h2 id="deep-heading" className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            深度追踪：把瓜吃到完整
          </h2>
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-300">
            不做情绪搬运，只做时间线、证据链与各方回应。一个事件从起点到落点，一次讲清楚。
          </p>
        </div>
        <Link
          to="/category/deep"
          className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-700 px-4 py-2 text-sm font-medium text-background-100 transition-colors hover:border-primary-400 hover:text-primary-300"
        >
          查看全部深度
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <Link to={`/post/${main.id}`} className="group relative block h-[280px] overflow-hidden rounded-lg md:h-[360px]">
          <img
            src={main.cover}
            alt={main.coverAlt}
            className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-transparent"></div>
          <div className="absolute inset-x-0 bottom-0 p-6">
            <h3 className="font-heading text-xl font-bold leading-snug text-white md:text-2xl">{main.title}</h3>
            <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-white/75">{main.summary}</p>
          </div>
        </Link>

        <div className="flex flex-col gap-4">
          {rest.map((post) => (
            <Link
              key={post.id}
              to={`/post/${post.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-800 bg-background-900 p-4 transition-colors hover:border-primary-500"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-list-check-2 text-xl" aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-base font-semibold leading-snug text-background-50 transition-colors group-hover:text-primary-300">
                  {post.title}
                </h3>
                <div className="mt-2 flex flex-wrap items-center gap-3 text-xs text-background-400">
                  <span>{post.publishedAt}</span>
                  <span>{post.readMinutes} 分钟读完</span>
                </div>
              </div>
            </Link>
          ))}
          <div className="rounded-lg border border-background-800 bg-background-900 p-5">
            <p className="text-sm leading-relaxed text-background-300">
              <strong className="text-accent-400">72 小时原则：</strong>
              涉及争议的事件，我们会先给 72 小时的观察期，等各方回应齐了再发长文，而不是抢第一个热搜。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}